import script from "./productService.vue?vue&type=script&lang=ts&setup=true"
export * from "./productService.vue?vue&type=script&lang=ts&setup=true"

import "./productService.vue?vue&type=style&index=0&id=bd543498&lang=scss&scoped=true"

import exportComponent from "D:\\yuntian\\eso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd543498"]])

export default __exports__